import React from "react";
import Header from "../header/Header";
import { Box } from "@mui/material";
import { HEADER_HEIGHT } from "../../../../utils/ui.constants";

function BasicLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header useMenu={false} useSearch={false} />
      <Box
        sx={{
          height: "auto",
          minHeight: `calc(100vh - ${HEADER_HEIGHT})`,
          backgroundColor: "background.default",
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default BasicLayout;
